
import React from 'react';
import { Helmet } from 'react-helmet';
import { ShortContentItem } from '@/hooks/useShortContent';

interface TravelByteStructuredDataProps {
  item: ShortContentItem;
  baseUrl: string;
}

export function TravelByteStructuredData({ item, baseUrl }: TravelByteStructuredDataProps) {
  // Create the structured data for travel byte content
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `${baseUrl}/travel-bytes/${item.slug}`
    },
    "headline": item.title,
    "description": item.content.substring(0, 160).replace(/<[^>]*>/g, ''), // Strip HTML tags
    "image": item.image_url ? {
      "@type": "ImageObject",
      "url": item.image_url,
      "width": 1200,
      "height": 630
    } : undefined,
    "author": {
      "@type": "Organization",
      "name": "Trotting the World"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Trotting the World",
      "logo": {
        "@type": "ImageObject",
        "url": `${baseUrl}/logo.png`,
        "width": 600,
        "height": 60
      }
    },
    "datePublished": item.publish_date ? new Date(item.publish_date).toISOString() : new Date(item.created_at).toISOString(),
    "dateModified": new Date(item.updated_at).toISOString(),
    "articleSection": item.category || "Travel",
    "keywords": `travel, ${item.content_type}, ${item.category || ''}`.split(',').filter(Boolean).join(', '),
    "inLanguage": "en-US",
    "genre": item.content_type,
    "about": {
      "@type": "Thing",
      "name": item.category || "Travel"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
